// /* global google */

// import {
//   GoogleMap,
//   Marker,
//   InfoWindow,
//   Polyline,
//   Polygon,
//   useJsApiLoader,
//   MarkerClusterer,
//   Circle,
// } from "@react-google-maps/api";
// import { useState, useEffect, useMemo, useRef } from "react";
// import MDTypography from "components/MDTypography";
// import MDBox from "components/MDBox";
// import PropTypes from "prop-types";
// import { useNavigate } from "react-router-dom";
// import VehicleDashboard from "./VehicleDashboard";

// import BusIconGray from "assets/images/marker_gray.png";
// import BusIconRed from "assets/images/marker_red.png";
// import BusIconGreen from "assets/images/marker_green.png";
// import BusIconYellow from "assets/images/marker_yellow.png";
// import realBus from "assets/images/0.png"
// import StopIcon from "assets/images/stop_marker.png";
// import { useSelector, useDispatch } from "react-redux"; // <-- Added useDispatch
// import { useMediaQuery } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import { useMaterialUIController } from "context";
// import axios from "axios";
// import focus from "assets/focus.png";
// import focus_dark from "assets/focus-dark.png";
// import satellite from "assets/satellite.png";
// import satellite_dark from "assets/satellite-dark.png";
// import label_dark from "assets/label-dark.png";
// import label from "assets/label.png";
// import { setSelectedVehicleNumber } from "../../features/live_map/fleetSlice"; // <-- Adjust Path
// import { FONT_SIZE, FONT_SIZE_PX, RADIUS, SHADOW, SIGNAL, GLASS } from "./theme/uiTokens";
// // import { GOOGLE_MAPS_API_KEY } from "config/apis";
// import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES } from "config/apis";

// // const GOOGLE_MAPS_LIBRARIES = ["geometry", "places", "drawing"];

// const containerStyle = {
//   width: "100%",
//   height: "100%",
//   borderRadius: "10px",
// };

// const defaultCenter = {
//   lat: 17.3850,
//   lng: 78.4867,
// };

// // Map control button style, sized responsively (smaller, tighter on phones).
// // Buttons live inside a single glass "cluster" panel (see wrapper below), so
// // each one is transparent by default and only lights up on hover/active.
// const getControlBtnStyle = (isMobile, active = false) => ({
//   background: active ? SIGNAL.gradientSoft : "transparent",
//   width: isMobile ? 34 : 38,
//   height: isMobile ? 34 : 38,
//   padding: 0,
//   borderRadius: `${RADIUS.sm}px`,
//   cursor: "pointer",
//   border: "none",
//   fontWeight: 600,
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   transition: "background 0.15s ease, transform 0.15s ease",
// });

// // The glass panel that groups the control buttons into one premium cluster.
// const controlClusterStyle = (isMobile, darkMode) => ({
//   display: "flex",
//   flexDirection: "column",
//   gap: isMobile ? 2 : 4,
//   padding: isMobile ? 4 : 6,
//   borderRadius: `${RADIUS.lg}px`,
//   background: darkMode ? GLASS.dark.panel : GLASS.light.panel,
//   backdropFilter: "blur(12px)",
//   border: `1px solid ${darkMode ? GLASS.dark.border : GLASS.light.border}`,
//   boxShadow: SHADOW.md,
// });

// const getDistance = (p1, p2) => {
//   const R = 6371e3; // metres
//   const phi1 = (p1.lat * Math.PI) / 180;
//   const phi2 = (p2.lat * Math.PI) / 180;
//   const deltaPhi = ((p2.lat - p1.lat) * Math.PI) / 180;
//   const deltaLambda = ((p2.lng - p1.lng) * Math.PI) / 180;

//   const a = Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
//     Math.cos(phi1) * Math.cos(phi2) *
//     Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// const iconCache = {};

// const getCachedIcon = async (bearing = 0) => {
//   const safeBearing = parseFloat(bearing) || 0;
//   const cacheKey = `bus-${safeBearing}`;

//   if (iconCache[cacheKey]) return iconCache[cacheKey];

//   const canvas = document.createElement("canvas");
//   const ctx = canvas.getContext("2d");
//   const size = 50;

//   return new Promise((resolve) => {
//     const img = new Image();

//     img.onload = () => {
//       canvas.width = size;
//       canvas.height = size;

//       ctx.translate(size / 2, size / 2);
//       ctx.rotate((safeBearing * Math.PI) / 180);
//       ctx.translate(-size / 2, -size / 2);

//       ctx.drawImage(img, 0, 0, size, size);

//       const url = canvas.toDataURL();
//       iconCache[cacheKey] = url;
//       resolve(url);
//     };

//     img.onerror = () => resolve(realBus);
//     img.src = realBus;
//   });
// };

// const getVehicleColor = (vehicle) => {
//   const speed = parseFloat(vehicle.speed);
//   const now = Date.now();
//   const isStale = vehicle.rawTime && vehicle.rawTime + 3600000 < now;

//   if (isStale) return "#9e9e9e";
//   if (vehicle.ignition === "ON" && speed > 0) return "#4caf50";
//   if (vehicle.ignition === "ON" && speed === 0) return "#ff9800";
//   if (vehicle.ignition === "OFF") return "#f44336";
//   return "#9e9e9e";
// };

// // --- NEW COMPONENT: SmoothMarker ---
// const SmoothMarker = ({ position, vehicle, children, onPositionChange, clusterer, ...props }) => {
//   const [renderPosition, setRenderPosition] = useState(position);
//   const [marker, setMarker] = useState(null);
//   const positionRef = useRef(position);
//   const animationRef = useRef(null);
//   const [iconUrl, setIconUrl] = useState("");

//   useEffect(() => {
//     let isMounted = true;
//     const loadIcon = async () => {
//       const bearing = parseFloat(vehicle.bearing) || 0;
//       const icon = await getCachedIcon(bearing);
//       if (isMounted) setIconUrl(icon);
//     };
//     loadIcon();
//     return () => { isMounted = false; };
//   }, [vehicle.bearing]);

//   useEffect(() => {
//     const startPos = positionRef.current;
//     const endPos = position;

//     // FIX 1: Agar vehicle move nahi hua, toh bhi circle ko sync rakho
//     if (startPos.lat === endPos.lat && startPos.lng === endPos.lng) {
//       onPositionChange && onPositionChange(endPos);
//       return;
//     }

//     const distanceThreshold = 0.5;
//     if (
//       Math.abs(startPos.lat - endPos.lat) > distanceThreshold ||
//       Math.abs(startPos.lng - endPos.lng) > distanceThreshold
//     ) {
//       setRenderPosition(endPos);
//       positionRef.current = endPos;
//       // FIX 2: Lamba jump aane par circle update karo
//       onPositionChange && onPositionChange(endPos);
//       return;
//     }

//     const startTime = performance.now();
//     const duration = 4000;

//     const animate = (time) => {
//       const elapsed = time - startTime;
//       const progress = Math.min(elapsed / duration, 1);

//       const lat = startPos.lat + (endPos.lat - startPos.lat) * progress;
//       const lng = startPos.lng + (endPos.lng - startPos.lng) * progress;

//       const currentPos = { lat, lng };
//       setRenderPosition(currentPos);
//       positionRef.current = currentPos;

//       onPositionChange && onPositionChange(currentPos);

//       if (progress < 1) {
//         animationRef.current = requestAnimationFrame(animate);
//       } else {
//         setRenderPosition(endPos);
//         positionRef.current = endPos;
//         // FIX 3: Animation complete hone par exact last position pe circle set karo
//         onPositionChange && onPositionChange(endPos);
//       }
//     };

//     animationRef.current = requestAnimationFrame(animate);

//     return () => {
//       if (animationRef.current) {
//         cancelAnimationFrame(animationRef.current);
//       }
//     };
//   }, [position.lat, position.lng]);

//   return (
//     <Marker
//       position={renderPosition}
//       clusterer={clusterer}
//       onLoad={(m) => setMarker(m)}
//       icon={{
//         url: iconUrl,
//         scaledSize: new window.google.maps.Size(40, 40),
//         anchor: new window.google.maps.Point(20, 20),
//       }}
//       {...props}
//     >
//       {marker && children &&
//         (Array.isArray(children) ? children : [children]).map((child, index) => {
//           if (child.type === InfoWindow) {
//             return Object.assign({}, child, {
//               props: { ...child.props, anchor: marker }
//             });
//           }
//           return child;
//         })
//       }
//     </Marker>
//   );
// };

// SmoothMarker.propTypes = {
//   position: PropTypes.shape({
//     lat: PropTypes.number.isRequired,
//     lng: PropTypes.number.isRequired,
//   }).isRequired,
//   children: PropTypes.node,
// };

// // --- MAIN COMPONENT ---
// // Notice: removed responsedata, activeFilter, selectedVehicleNumber from props
// const GoogleMapView = ({ onVehicleSelect }) => {
//   const dispatch = useDispatch();

//   // 👇 GETTING DATA DIRECTLY FROM REDUX
//   const {
//     myThings,
//     latestUpdates,
//     geoFences,
//     selectedVehicleNumber,
//     activeFilter,
//     searchQuery,
//   } = useSelector((state) => state.fleet || {});

//   const responsedata = useMemo(() => ({
//     myThings: myThings || {},
//     latestUpdates: latestUpdates || {}
//   }), [myThings, latestUpdates]);


//   const [selectedVehicle, setSelectedVehicle] = useState(null);
//   const [selectedStop, setSelectedStop] = useState(null);
//   const [openInfoVehicleId, setOpenInfoVehicleId] = useState(null);
//   const [pulseRadius, setPulseRadius] = useState(20);
//   const [pulseOpacity, setPulseOpacity] = useState(0.4);
//   const [animatedPosition, setAnimatedPosition] = useState(null);
//   const mapRef = useRef(null);
//   const centerRef = useRef(defaultCenter);

//   const [showAllLabels, setShowAllLabels] = useState(false);
//   const [mapType, setMapType] = useState("roadmap");
//   const [autoFocus, setAutoFocus] = useState(false);
//   const [isClusteringEnabled, setIsClusteringEnabled] = useState(true);
//   const hasFocusedOnceRef = useRef(false);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const navigate = useNavigate();
//   const [controller] = useMaterialUIController();
//   const { darkMode } = controller;

//   const { isLoaded, loadError } = useJsApiLoader({
//     googleMapsApiKey: GOOGLE_MAPS_API_KEY,
//     libraries: GOOGLE_MAPS_LIBRARIES,
//   });

//   useEffect(() => {
//     if (selectedVehicle) {
//       setAnimatedPosition(selectedVehicle.position);
//     } else {
//       setAnimatedPosition(null);
//     }
//   }, [selectedVehicle?.vehicleNumber]);

//   useEffect(() => {
//     if (!selectedVehicle) return;

//     let growing = true;

//     const interval = setInterval(() => {
//       setPulseRadius((prev) => {
//         if (prev > 50) growing = false;
//         if (prev < 20) growing = true;
//         return growing ? prev + 4 : prev - 4;
//       });

//       setPulseOpacity((prev) => {
//         return prev > 0.2 ? 0.05 : 0.2;
//       });
//     }, 100);

//     return () => clearInterval(interval);
//   }, [selectedVehicle]);

//   const { journeys, data: catchmentFullData, selectedJourneyId } = useSelector((state) => state.catchmentData);

//   const vehicles = useMemo(() => {
//     const myThingsData = responsedata?.myThings || {};
//     const latestUpdatesData = responsedata?.latestUpdates || {};

//     return Object.entries(myThingsData).map(([vehicleNumber, data]) => {
//       const latest = latestUpdatesData[vehicleNumber]?.latest?.MOBILE || {};
//       const location = latest?.location || {};
//       const journeyAvailable = data?.journeyAvailable === true;
//       const journeyData = data?.currentJourney || {};
//       const stops = data?.stops || {};

//       const lat = parseFloat(location.latitude);
//       const lng = parseFloat(location.longitude);

//       const sequenceMap = journeyData?.sequence || {};

//       const sortedStops = Object.keys(sequenceMap)
//         .sort((a, b) => parseInt(a) - parseInt(b))
//         .map((key) => {
//           const stopId = sequenceMap[key];
//           const stopData = stops[stopId];
//           return {
//             ...stopData,
//             stopId: stopId,
//             displayIndex: parseInt(key) + 1,
//           };
//         })
//         .filter(s => s.location);

//       return {
//         vehicleNumber: data?.thing?.thingId,
//         vehicleNickName: data?.thing?.nickName,
//         position: {
//           lat: isNaN(lat) ? defaultCenter.lat : lat,
//           lng: isNaN(lng) ? defaultCenter.lng : lng,
//         },
//         ignition:
//           latest?.ignition ?? data?.latest?.MOBILE?.ignition ? "ON" : "OFF",
//         bearing:
//           latest?.bearing ?? data?.latest?.MOBILE?.bearing,
//         speed: latest?.speed ? parseFloat(latest.speed).toFixed(2) : "0.00",
//         rawTime: latest?.updatedAt ? latest.updatedAt : "",
//         journeyName: journeyAvailable
//           ? journeyData?.journeyName || "N/A"
//           : "N/A",
//         journeyType: journeyAvailable ? journeyData?.type || "N/A" : "N/A",
//         progress: data?.progress || 0,
//         routeCoordinates: journeyData?.wayPointsPolyLine || [],
//         stops: sortedStops,
//         geofence: journeyData?.geofence || [],
//         status: data?.journeyStatus || "unknown",
//         journeyAvailable,
//       };
//     });
//   }, [responsedata]);

//   const pathData = useMemo(() => {
//     if (!window.google || !window.google.maps || !window.google.maps.geometry) {
//       return null;
//     }

//     if (!selectedVehicle || !selectedVehicle.routeCoordinates) return null;

//     try {
//       const fullPath = window.google.maps.geometry.encoding.decodePath(selectedVehicle.routeCoordinates)
//         .map(p => ({ lat: p.lat(), lng: p.lng() }));

//       if (fullPath.length === 0) return null;

//       let minDistance = Infinity;
//       let matchIndex = 0;
//       const vehiclePos = selectedVehicle.position;

//       fullPath.forEach((point, index) => {
//         const dist = getDistance(point, vehiclePos);
//         if (dist < minDistance) {
//           minDistance = dist;
//           matchIndex = index;
//         }
//       });

//       return {
//         covered: fullPath.slice(0, matchIndex + 1),
//         remaining: fullPath.slice(matchIndex)
//       };
//     } catch (error) {
//       console.error("Error decoding path:", error);
//       return null;
//     }
//   }, [selectedVehicle, window.google]);

//   const filteredVehicles = useMemo(() => {
//     const now = Date.now();

//     // 🔥 Default: If no filter active, return all vehicles
//     if (!activeFilter || activeFilter === "@total") return vehicles;

//     return vehicles.filter((v) => {
//       const speed = parseFloat(v.speed);
//       const isStale = v.rawTime && v.rawTime + 3600000 < now;
//       const isIgnitionOn = v.ignition === "ON";

//       switch (activeFilter) {
//         case "@offline": return isStale;
//         case "@running": return !isStale && isIgnitionOn && speed >= 0.25;
//         case "@idle": return !isStale && isIgnitionOn && speed < 0.25;
//         case "@parked": return !isStale && !isIgnitionOn;
//         case "@onroute": return v.journeyAvailable === true;
//         default: return true;
//       }
//     });
//   }, [vehicles, activeFilter]);

//   useEffect(() => {
//     if (!selectedVehicleNumber) {
//       setSelectedVehicle(null);
//       setSelectedStop(null);
//       setOpenInfoVehicleId(null);
//       return;
//     }

//     const vehicle = vehicles.find(
//       (v) =>
//         String(v.vehicleNumber).trim() ===
//         String(selectedVehicleNumber).trim()
//     );

//     setSelectedVehicle(vehicle || null);
//   }, [vehicles, selectedVehicleNumber]);

//   useEffect(() => {
//     if (activeFilter) {
//       setSelectedVehicle(null);
//       dispatch(setSelectedVehicleNumber(null));
//     }
//   }, [activeFilter]);

//   useEffect(() => {
//     if (autoFocus && selectedVehicle && mapRef.current) {
//       if (selectedVehicle?.position?.lat && selectedVehicle?.position?.lng) {
//         mapRef.current.panTo(selectedVehicle.position);
//         mapRef.current.setZoom(17);
//       }
//     }
//   }, [selectedVehicle, autoFocus, activeFilter]);

//   useEffect(() => {
//     if (autoFocus && selectedJourneyId && journeys.length > 0 && mapRef.current) {
//       const journey = journeys.find(j => j.journeyId === selectedJourneyId);
//       if (journey?.encodedPath) {
//         const path = window.google.maps.geometry.encoding.decodePath(journey.encodedPath);
//         const bounds = new google.maps.LatLngBounds();
//         path.forEach(p => bounds.extend(p));
//         mapRef.current.fitBounds(bounds);
//       }
//     }
//   }, [selectedJourneyId, journeys, autoFocus]);

//   useEffect(() => {
//     if (!autoFocus) return;

//     if (selectedVehicle) {
//       centerRef.current = selectedVehicle.position;
//     } else if (filteredVehicles.length > 0) {
//       centerRef.current = {
//         lat:
//           filteredVehicles.reduce((sum, v) => sum + v.position.lat, 0) /
//           filteredVehicles.length,
//         lng:
//           filteredVehicles.reduce((sum, v) => sum + v.position.lng, 0) /
//           filteredVehicles.length,
//       };
//     }
//   }, [selectedVehicle, autoFocus, filteredVehicles]);

//   useEffect(() => {
//     // Check if latestUpdates has data
//     const hasData = latestUpdates && Object.keys(latestUpdates).length > 0;

//     if (hasData && !hasFocusedOnceRef.current && mapRef.current) {
//       const bounds = new window.google.maps.LatLngBounds();

//       vehicles.forEach((v) => {
//         if (v.position?.lat && v.position?.lng) {
//           bounds.extend(v.position);
//         }
//       });

//       if (!bounds.isEmpty()) {
//         mapRef.current.fitBounds(bounds);
//         hasFocusedOnceRef.current = true; // ✅ only once
//       }
//     }
//   }, [latestUpdates, vehicles]);

//   //added new effect for singal vehicle focus
//   useEffect(() => {
//     if (
//       selectedVehicle &&
//       mapRef.current &&
//       selectedVehicle?.position?.lat &&
//       selectedVehicle?.position?.lng
//     ) {
//       mapRef.current.panTo(selectedVehicle.position);
//       mapRef.current.setZoom(17);
//     }
//   }, [selectedVehicle?.vehicleNumber]);

//   useEffect(() => {
//     if (autoFocus && filteredVehicles.length > 0 && mapRef.current && !selectedVehicle) {
//       const bounds = new google.maps.LatLngBounds();
//       filteredVehicles.forEach((v) => bounds.extend(v.position));
//       mapRef.current.fitBounds(bounds);
//     }
//   }, [autoFocus, filteredVehicles, selectedVehicle]);

//   const mapCenter = centerRef.current;

//   // Helper function taaki markers ko clustered aur un-clustered dono modes mein reuse kar sakein
//   const renderVehicles = (clusterer = undefined) => {
//     return filteredVehicles.map((vehicle) => (
//       <SmoothMarker
//         key={vehicle.vehicleNumber}
//         position={vehicle.position}
//         vehicle={vehicle}
//         clusterer={clusterer} // Agar disabled hoga toh ye undefined jayega
//         animation={window.google.maps.Animation.DROP}
//         onClick={() => {
//           onVehicleSelect?.(vehicle.vehicleNumber);
//         }}
//       >
//         {(openInfoVehicleId === vehicle.vehicleNumber || showAllLabels) && (
//           <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)}>
//             <MDBox p={0} sx={{ whiteSpace: "nowrap" }}>
//               <MDTypography variant="subtitle2" fontWeight="bold" display="block" sx={{ fontSize: FONT_SIZE.subtitle, lineHeight: 1.3 }}>
//                 {vehicle.vehicleNumber}
//               </MDTypography>
//               <MDTypography variant="caption" color="text" fontWeight="regular" display="block" sx={{ fontSize: FONT_SIZE.small }}>
//                 {vehicle.vehicleNickName}
//               </MDTypography>
//             </MDBox>
//           </InfoWindow>
//         )}
//       </SmoothMarker>
//     ));
//   };

//   if (loadError) {
//     return (
//       <MDBox p={2}>
//         <MDTypography variant="body2" color="error">
//           Failed to load Google Maps. Please check your internet connection or API key.
//         </MDTypography>
//       </MDBox>
//     );
//   }

//   if (!isLoaded) {
//     return (
//       <MDBox p={2}>
//         <MDTypography variant="body2" color="text">
//           Loading map...
//         </MDTypography>
//       </MDBox>
//     );
//   }

//   return (
//     <>
//       <div
//         style={{
//           position: "absolute",
//           top: isMobile ? 12 : 20,
//           right: isMobile ? 12 : 20,
//           zIndex: 1,
//           ...controlClusterStyle(isMobile, darkMode),
//         }}
//       >
//         <button
//           style={getControlBtnStyle(isMobile, showAllLabels)}
//           onClick={() => setShowAllLabels(!showAllLabels)}
//           title={showAllLabels ? "Hide Labels" : "Show Labels"}
//           onMouseEnter={(e) => { if (!showAllLabels) e.currentTarget.style.background = "rgba(148,163,184,0.16)"; }}
//           onMouseLeave={(e) => { if (!showAllLabels) e.currentTarget.style.background = "transparent"; }}
//         >
//           <img
//             src={showAllLabels ? label_dark : label}
//             style={{ width: isMobile ? 18 : 20, height: isMobile ? 18 : 20 }}
//             alt="labels"
//           />
//         </button>

//         <button
//           style={getControlBtnStyle(isMobile, mapType === "hybrid")}
//           onClick={() =>
//             setMapType((prev) => (prev === "roadmap" ? "hybrid" : "roadmap"))}
//           title={mapType === "roadmap" ? "Satellite View" : "Roadmap View"}
//           onMouseEnter={(e) => { if (mapType !== "hybrid") e.currentTarget.style.background = "rgba(148,163,184,0.16)"; }}
//           onMouseLeave={(e) => { if (mapType !== "hybrid") e.currentTarget.style.background = "transparent"; }}
//         >
//           <img
//             src={mapType === "hybrid" ? satellite : satellite_dark}
//             style={{ width: isMobile ? 18 : 20, height: isMobile ? 18 : 20 }}
//             alt="map-type"
//           />
//         </button>

//         <button
//           style={getControlBtnStyle(isMobile, autoFocus)}
//           onClick={() => setAutoFocus(!autoFocus)}
//           title={autoFocus ? "Focus: ON (Click to Disable)" : "Focus: OFF (Click to Enable)"}
//           onMouseEnter={(e) => { if (!autoFocus) e.currentTarget.style.background = "rgba(148,163,184,0.16)"; }}
//           onMouseLeave={(e) => { if (!autoFocus) e.currentTarget.style.background = "transparent"; }}
//         >
//           <img
//             src={autoFocus ? focus : focus_dark}
//             style={{ width: isMobile ? 18 : 20, height: isMobile ? 18 : 20 }}
//             alt="focus"
//           />
//         </button>

//         <button
//           style={getControlBtnStyle(isMobile, isClusteringEnabled)}
//           onClick={() => setIsClusteringEnabled(!isClusteringEnabled)}
//           title={isClusteringEnabled ? "Disable Clustering" : "Enable Clustering"}
//           onMouseEnter={(e) => { if (!isClusteringEnabled) e.currentTarget.style.background = "rgba(148,163,184,0.16)"; }}
//           onMouseLeave={(e) => { if (!isClusteringEnabled) e.currentTarget.style.background = "transparent"; }}
//         >
//           {/* Custom SVG Icon - Asset import karne ki zarurat nahi padegi */}
//           <svg
//             width={isMobile ? 18 : 20}
//             height={isMobile ? 18 : 20}
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke={isClusteringEnabled ? SIGNAL.violet : "#94A3B8"}
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           >
//             <circle cx="12" cy="12" r="3"></circle>
//             <circle cx="19" cy="5" r="2"></circle>
//             <circle cx="5" cy="5" r="2"></circle>
//             <circle cx="19" cy="19" r="2"></circle>
//             <circle cx="5" cy="19" r="2"></circle>
//             <path d="M10.5 10.5L7 7 M13.5 10.5L17 7 M10.5 13.5L7 17 M13.5 13.5L17 17"></path>
//           </svg>
//         </button>
//       </div>

//       <GoogleMap
//         mapContainerStyle={containerStyle}
//         // center={autoFocus ? mapCenter : undefined}
//         center={mapCenter || defaultCenter}
//         zoom={selectedVehicle ? 15 : 9}
//         onLoad={(map) => (mapRef.current = map)}
//         options={{
//           mapTypeId: mapType,
//           mapTypeControl: false,
//           streetViewControl: false,
//           fullscreenControl: false,
//         }}
//       >
//         {selectedVehicle && (activeFilter === "@total" || !activeFilter || searchQuery === selectedVehicle.vehicleNumber) ? (
//           <>
//             {animatedPosition && (
//               <Circle
//                 center={animatedPosition}
//                 radius={pulseRadius}
//                 options={{
//                   strokeColor: getVehicleColor(selectedVehicle),
//                   strokeOpacity: 0.3,
//                   strokeWeight: 2,
//                   fillColor: getVehicleColor(selectedVehicle),
//                   fillOpacity: pulseOpacity,
//                 }}
//               />
//             )}
//             <SmoothMarker
//               key={selectedVehicle.vehicleNumber}
//               position={selectedVehicle.position}
//               vehicle={selectedVehicle}
//               onPositionChange={setAnimatedPosition}
//               animation={google.maps.Animation.DROP}
//               onClick={() => {
//                 setOpenInfoVehicleId((prev) =>
//                   prev === selectedVehicle.vehicleNumber ? null : selectedVehicle.vehicleNumber
//                 );
//               }}
//             >
//               {(openInfoVehicleId === selectedVehicle.vehicleNumber || showAllLabels) && (
//                 <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)} options={{ maxWidth: 160 }}>
//                   <MDBox p={0} sx={{ overflow: "hidden", display: "block", whiteSpace: "nowrap", lineHeight: 1.3 }}>
//                     <MDTypography variant="subtitle2" fontWeight="bold" display="block" sx={{ fontSize: FONT_SIZE.subtitle }}>
//                       {selectedVehicle.vehicleNumber}
//                     </MDTypography>
//                     <MDTypography variant="caption" color="text" fontWeight="regular" display="block" sx={{ fontSize: FONT_SIZE.small }}>
//                       {selectedVehicle.vehicleNickName}
//                     </MDTypography>
//                   </MDBox>
//                 </InfoWindow>
//               )}
//             </SmoothMarker>
//           </>
//         ) : (
//           <>
//             {isClusteringEnabled ? (
//               <MarkerClusterer
//                 options={{
//                   gridSize: 60,
//                   minimumClusterSize: 2,
//                   imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
//                 }}
//               >
//                 {(clusterer) => <>{renderVehicles(clusterer)}</>}
//               </MarkerClusterer>
//             ) : (
//               // Jab clustering disable hogi, directly array render hoga
//               <>{renderVehicles()}</>
//             )}
//           </>
//         )}

//         {!selectedJourneyId && pathData && (
//           <>
//             <Polyline
//               path={pathData.covered}
//               options={{
//                 strokeColor: "#2bbf9f",
//                 strokeOpacity: 1.0,
//                 strokeWeight: 4,
//               }}
//             />
//             <Polyline
//               path={pathData.remaining}
//               options={{
//                 strokeColor: "#f07846",
//                 strokeOpacity: 0.8,
//                 strokeWeight: 4,
//                 lineDashInterval: 10,
//               }}
//             />
//           </>
//         )}

//         {selectedJourneyId && journeys.length > 0 && (
//           <>
//             {(() => {
//               const journey = journeys.find(j => j.journeyId === selectedJourneyId);
//               if (journey?.encodedPath) {
//                 return (
//                   <Polyline
//                     path={window.google.maps.geometry.encoding.decodePath(journey.encodedPath)}
//                     options={{
//                       strokeColor: "#000000",
//                       strokeOpacity: 1.0,
//                       strokeWeight: 4,
//                     }}
//                   />
//                 );
//               }
//             })()}

//             {catchmentFullData?.data?.allWayPoints
//               ?.find(j => j.journeyId === selectedJourneyId)
//               ?.stopPoints?.map((stop, index) => (
//                 <Marker
//                   key={`catchment-stop-${index}`}
//                   position={{
//                     lat: parseFloat(stop.location.latitude),
//                     lng: parseFloat(stop.location.longitude),
//                   }}
//                   icon={{
//                     url: StopIcon,
//                     scaledSize: new window.google.maps.Size(28, 28),
//                   }}
//                   label={{
//                     color: "#fff",
//                     text: `${index + 1}`,
//                     fontSize: `${FONT_SIZE_PX.small}px`,
//                     fontWeight: "bold",
//                   }}
//                   onClick={() => {
//                     const currentId = `c-${index}`;
//                     setSelectedStop((prev) =>
//                       prev?.id === currentId ? null : { id: currentId, name: stop.locationName }
//                     );
//                   }}
//                 >
//                   {selectedStop?.id === `c-${index}` && (
//                     <InfoWindow onCloseClick={() => setSelectedStop(null)}>
//                       <MDBox p={0} sx={{ whiteSpace: "nowrap" }}>
//                         <MDTypography variant="subtitle2" fontWeight="bold" sx={{ fontSize: FONT_SIZE.subtitle }}>
//                           {stop.locationName}
//                         </MDTypography>
//                       </MDBox>
//                     </InfoWindow>
//                   )}
//                 </Marker>
//               ))}
//           </>
//         )}

//         {!selectedJourneyId &&
//           selectedVehicle?.journeyAvailable &&
//           Array.isArray(selectedVehicle?.stops) &&
//           selectedVehicle.stops.map((stop, index) => {
//             return (
//               <Marker
//                 key={stop.stopId || index}
//                 position={{
//                   lat: parseFloat(stop.location.latitude),
//                   lng: parseFloat(stop.location.longitude),
//                 }}
//                 icon={{
//                   url: StopIcon,
//                   scaledSize: new window.google.maps.Size(28, 28),
//                 }}
//                 label={{
//                   color: "#fff",
//                   text: String(stop.displayIndex),
//                   fontSize: `${FONT_SIZE_PX.small}px`,
//                   fontWeight: "bold",
//                 }}
//                 onClick={() => {
//                   setSelectedStop((prev) =>
//                     prev?.id === stop.stopId ? null : { id: stop.stopId, name: stop.locationName }
//                   );
//                 }}
//               >
//                 {selectedStop?.id === stop.stopId && (
//                   <InfoWindow onCloseClick={() => setSelectedStop(null)}>
//                     <MDBox p={0} sx={{ whiteSpace: "nowrap" }}>
//                       <MDTypography variant="subtitle2" fontWeight="bold" sx={{ fontSize: FONT_SIZE.subtitle }}>
//                         {stop.displayIndex}. {stop.locationName}
//                       </MDTypography>
//                     </MDBox>
//                   </InfoWindow>
//                 )}
//               </Marker>
//             );
//           })}

//         {selectedVehicle?.geofence?.length > 0 && (
//           <Polygon
//             paths={selectedVehicle.geofence}
//             options={{
//               strokeColor: "#FF9800",
//               strokeOpacity: 0.8,
//               strokeWeight: 2,
//               fillColor: "#FF9800",
//               fillOpacity: 0.35,
//             }}
//           />
//         )}

//         {(geoFences || []).map((geofence, index) => {
//           const data = geofence.data || {};

//           if (geofence.type === "POLYGON" && Array.isArray(data.coordinates) && data.coordinates.length > 0) {
//             const paths = data.coordinates.map(([lng, lat]) => ({ lat, lng }));
//             return (
//               <Polygon
//                 key={`geofence-polygon-${geofence.filterId || index}`}
//                 paths={paths}
//                 options={{
//                   strokeColor: "#666666",
//                   strokeOpacity: 1,
//                   strokeWeight: 2,
//                   fillColor: "#0c0808",
//                   fillOpacity: 0.3,
//                 }}
//               />
//             );
//           }

//           const location = data.location;
//           const radius = data.radius || 100;
//           if (!location?.latitude || !location?.longitude) return null;
//           return (
//             <Circle
//               key={`geofence-circle-${geofence.filterId || index}`}
//               center={{ lat: location.latitude, lng: location.longitude }}
//               radius={radius}
//               options={{
//                 strokeColor: "#666666",
//                 strokeOpacity: 1,
//                 strokeWeight: 5,
//                 fillColor: "#0c0808",
//                 fillOpacity: 0.3,
//               }}
//             />
//           );
//         })}

//         {/* {(geoFences || []).map((geofence, index) => {
//           const location = geofence.data?.location;
//           const radius = geofence.data?.radius || 100;
//           if (!location?.latitude || !location?.longitude) return null;
//           return (
//             <Circle
//               key={`circle-${index}`}
//               center={{ lat: location.latitude, lng: location.longitude }}
//               radius={radius}
//               options={{
//                 strokeColor: "#666666",
//                 strokeOpacity: 1,
//                 strokeWeight: 5,
//                 fillColor: "#0c0808",
//                 fillOpacity: 0.3,
//               }}
//             />
//           );
//         })} */}
//       </GoogleMap>
//       <VehicleDashboard
//         vehicle={selectedVehicle}
//         onClose={() => {
//           setSelectedVehicle(null);
//           dispatch(setSelectedVehicleNumber(null));
//         }}
//       />
//     </>
//   );
// };

// GoogleMapView.propTypes = {
//   onVehicleSelect: PropTypes.func,
// };

// export default GoogleMapView;

/* global google */

import {
  GoogleMap,
  Marker,
  InfoWindow,
  Polyline,
  Polygon,
  useJsApiLoader,
  MarkerClusterer,
  Circle,
} from "@react-google-maps/api";
import { useState, useEffect, useMemo, useRef } from "react";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import VehicleDashboard from "./VehicleDashboard";

import BusIconGray from "assets/images/marker_gray.png";
import BusIconRed from "assets/images/marker_red.png";
import BusIconGreen from "assets/images/marker_green.png";
import BusIconYellow from "assets/images/marker_yellow.png";
import realBus from "assets/images/0.png"
import StopIcon from "assets/images/stop_marker.png";
import { useSelector, useDispatch } from "react-redux"; // <-- Added useDispatch
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMaterialUIController } from "context";
import axios from "axios";
import focus from "assets/focus.png";
import focus_dark from "assets/focus-dark.png";
import focus_light from "assets/focus.png";
import satellite from "assets/satellite.png";
import satellite_dark from "assets/satellite-dark.png";
import label_dark from "assets/label-dark.png";
import label from "assets/label.png";
import { setSelectedVehicleNumber } from "../../features/live_map/fleetSlice"; // <-- Adjust Path
import { FONT_SIZE, FONT_SIZE_PX, RADIUS, SHADOW, SIGNAL, GLASS } from "./theme/uiTokens";
// import { GOOGLE_MAPS_API_KEY } from "config/apis";
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES } from "config/apis";

// const GOOGLE_MAPS_LIBRARIES = ["geometry", "places", "drawing"];

const containerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "10px",
};

const defaultCenter = {
  lat: 17.3850,
  lng: 78.4867,
};

// Standard "dark" Google Maps style palette — applied to the map only when
// the app is in dark mode, via the `styles` option below.
const DARK_MAP_STYLES = [
  { elementType: "geometry", stylers: [{ color: "#1d2c34" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#1d2c34" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
  { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
  { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#263c3f" }] },
  { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#6b9a76" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#38414e" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#212a37" }] },
  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9ca5b3" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#746855" }] },
  { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#1f2835" }] },
  { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#f3d19c" }] },
  { featureType: "transit", elementType: "geometry", stylers: [{ color: "#2f3948" }] },
  { featureType: "transit.station", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#17263c" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#515c6d" }] },
  { featureType: "water", elementType: "labels.text.stroke", stylers: [{ color: "#17263c" }] },
];

// Map control button style, sized responsively (smaller, tighter on phones).
// Buttons live inside a single glass "cluster" panel (see wrapper below), so
// each one is transparent by default and only lights up on hover/active.
const getControlBtnStyle = (isMobile, active = false) => ({
  background: active ? SIGNAL.gradientSoft : "transparent",
  width: isMobile ? 34 : 38,
  height: isMobile ? 34 : 38,
  padding: 0,
  borderRadius: `${RADIUS.sm}px`,
  cursor: "pointer",
  border: "none",
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background 0.15s ease, transform 0.15s ease",
});

// The glass panel that groups the control buttons into one premium cluster.
const controlClusterStyle = (isMobile, darkMode) => ({
  display: "flex",
  flexDirection: "column",
  gap: isMobile ? 2 : 4,
  padding: isMobile ? 4 : 6,
  borderRadius: `${RADIUS.lg}px`,
  background: darkMode ? GLASS.dark.panel : GLASS.light.panel,
  backdropFilter: "blur(12px)",
  border: `1px solid ${darkMode ? GLASS.dark.border : GLASS.light.border}`,
  boxShadow: SHADOW.md,
});

const getDistance = (p1, p2) => {
  const R = 6371e3; // metres
  const phi1 = (p1.lat * Math.PI) / 180;
  const phi2 = (p2.lat * Math.PI) / 180;
  const deltaPhi = ((p2.lat - p1.lat) * Math.PI) / 180;
  const deltaLambda = ((p2.lng - p1.lng) * Math.PI) / 180;

  const a = Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
    Math.cos(phi1) * Math.cos(phi2) *
    Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

const iconCache = {};

const getCachedIcon = async (bearing = 0) => {
  const safeBearing = parseFloat(bearing) || 0;
  const cacheKey = `bus-${safeBearing}`;

  if (iconCache[cacheKey]) return iconCache[cacheKey];

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const size = 50;

  return new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      canvas.width = size;
      canvas.height = size;

      ctx.translate(size / 2, size / 2);
      ctx.rotate((safeBearing * Math.PI) / 180);
      ctx.translate(-size / 2, -size / 2);

      ctx.drawImage(img, 0, 0, size, size);

      const url = canvas.toDataURL();
      iconCache[cacheKey] = url;
      resolve(url);
    };

    img.onerror = () => resolve(realBus);
    img.src = realBus;
  });
};

const getVehicleColor = (vehicle) => {
  const speed = parseFloat(vehicle.speed);
  const now = Date.now();
  const isStale = vehicle.rawTime && vehicle.rawTime + 3600000 < now;

  if (isStale) return "#9e9e9e";
  if (vehicle.ignition === "ON" && speed > 0) return "#4caf50";
  if (vehicle.ignition === "ON" && speed === 0) return "#ff9800";
  if (vehicle.ignition === "OFF") return "#f44336";
  return "#9e9e9e";
};

// --- NEW COMPONENT: SmoothMarker ---
const SmoothMarker = ({ position, vehicle, children, onPositionChange, clusterer, ...props }) => {
  const [renderPosition, setRenderPosition] = useState(position);
  const [marker, setMarker] = useState(null);
  const positionRef = useRef(position);
  const animationRef = useRef(null);
  const [iconUrl, setIconUrl] = useState("");

  useEffect(() => {
    let isMounted = true;
    const loadIcon = async () => {
      const bearing = parseFloat(vehicle.bearing) || 0;
      const icon = await getCachedIcon(bearing);
      if (isMounted) setIconUrl(icon);
    };
    loadIcon();
    return () => { isMounted = false; };
  }, [vehicle.bearing]);

  useEffect(() => {
    const startPos = positionRef.current;
    const endPos = position;

    // FIX 1: Agar vehicle move nahi hua, toh bhi circle ko sync rakho
    if (startPos.lat === endPos.lat && startPos.lng === endPos.lng) {
      onPositionChange && onPositionChange(endPos);
      return;
    }

    const distanceThreshold = 0.5;
    if (
      Math.abs(startPos.lat - endPos.lat) > distanceThreshold ||
      Math.abs(startPos.lng - endPos.lng) > distanceThreshold
    ) {
      setRenderPosition(endPos);
      positionRef.current = endPos;
      // FIX 2: Lamba jump aane par circle update karo
      onPositionChange && onPositionChange(endPos);
      return;
    }

    const startTime = performance.now();
    const duration = 4000;

    const animate = (time) => {
      const elapsed = time - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const lat = startPos.lat + (endPos.lat - startPos.lat) * progress;
      const lng = startPos.lng + (endPos.lng - startPos.lng) * progress;

      const currentPos = { lat, lng };
      setRenderPosition(currentPos);
      positionRef.current = currentPos;

      onPositionChange && onPositionChange(currentPos);

      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animate);
      } else {
        setRenderPosition(endPos);
        positionRef.current = endPos;
        // FIX 3: Animation complete hone par exact last position pe circle set karo
        onPositionChange && onPositionChange(endPos);
      }
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [position.lat, position.lng]);

  return (
    <Marker
      position={renderPosition}
      clusterer={clusterer}
      onLoad={(m) => setMarker(m)}
      icon={{
        url: iconUrl,
        scaledSize: new window.google.maps.Size(40, 40),
        anchor: new window.google.maps.Point(20, 20),
      }}
      {...props}
    >
      {marker && children &&
        (Array.isArray(children) ? children : [children]).map((child, index) => {
          if (child.type === InfoWindow) {
            return Object.assign({}, child, {
              props: { ...child.props, anchor: marker }
            });
          }
          return child;
        })
      }
    </Marker>
  );
};

SmoothMarker.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  children: PropTypes.node,
};

// --- MAIN COMPONENT ---
// Notice: removed responsedata, activeFilter, selectedVehicleNumber from props
const GoogleMapView = ({ onVehicleSelect }) => {
  const dispatch = useDispatch();

  // 👇 GETTING DATA DIRECTLY FROM REDUX
  const {
    myThings,
    latestUpdates,
    geoFences,
    selectedVehicleNumber,
    activeFilter,
    searchQuery,
  } = useSelector((state) => state.fleet || {});

  const responsedata = useMemo(() => ({
    myThings: myThings || {},
    latestUpdates: latestUpdates || {}
  }), [myThings, latestUpdates]);


  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedStop, setSelectedStop] = useState(null);
  const [openInfoVehicleId, setOpenInfoVehicleId] = useState(null);
  const [pulseRadius, setPulseRadius] = useState(20);
  const [pulseOpacity, setPulseOpacity] = useState(0.4);
  const [animatedPosition, setAnimatedPosition] = useState(null);
  const mapRef = useRef(null);
  const centerRef = useRef(defaultCenter);

  const [showAllLabels, setShowAllLabels] = useState(false);
  const [mapType, setMapType] = useState("roadmap");
  const [autoFocus, setAutoFocus] = useState(false);
  const [isClusteringEnabled, setIsClusteringEnabled] = useState(true);
  const hasFocusedOnceRef = useRef(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  useEffect(() => {
    if (selectedVehicle) {
      setAnimatedPosition(selectedVehicle.position);
    } else {
      setAnimatedPosition(null);
    }
  }, [selectedVehicle?.vehicleNumber]);

  useEffect(() => {
    if (!selectedVehicle) return;

    let growing = true;

    const interval = setInterval(() => {
      setPulseRadius((prev) => {
        if (prev > 50) growing = false;
        if (prev < 20) growing = true;
        return growing ? prev + 4 : prev - 4;
      });

      setPulseOpacity((prev) => {
        return prev > 0.2 ? 0.05 : 0.2;
      });
    }, 100);

    return () => clearInterval(interval);
  }, [selectedVehicle]);

  const { journeys, data: catchmentFullData, selectedJourneyId } = useSelector((state) => state.catchmentData);

  const vehicles = useMemo(() => {
    const myThingsData = responsedata?.myThings || {};
    const latestUpdatesData = responsedata?.latestUpdates || {};

    return Object.entries(myThingsData).map(([vehicleNumber, data]) => {
      const latest = latestUpdatesData[vehicleNumber]?.latest?.MOBILE || {};
      const location = latest?.location || {};
      const journeyAvailable = data?.journeyAvailable === true;
      const journeyData = data?.currentJourney || {};
      const stops = data?.stops || {};

      const lat = parseFloat(location.latitude);
      const lng = parseFloat(location.longitude);

      const sequenceMap = journeyData?.sequence || {};

      const sortedStops = Object.keys(sequenceMap)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map((key) => {
          const stopId = sequenceMap[key];
          const stopData = stops[stopId];
          return {
            ...stopData,
            stopId: stopId,
            displayIndex: parseInt(key) + 1,
          };
        })
        .filter(s => s.location);

      return {
        vehicleNumber: data?.thing?.thingId,
        vehicleNickName: data?.thing?.nickName,
        position: {
          lat: isNaN(lat) ? defaultCenter.lat : lat,
          lng: isNaN(lng) ? defaultCenter.lng : lng,
        },
        ignition:
          latest?.ignition ?? data?.latest?.MOBILE?.ignition ? "ON" : "OFF",
        bearing:
          latest?.bearing ?? data?.latest?.MOBILE?.bearing,
        speed: latest?.speed ? parseFloat(latest.speed).toFixed(2) : "0.00",
        rawTime: latest?.updatedAt ? latest.updatedAt : "",
        journeyName: journeyAvailable
          ? journeyData?.journeyName || "N/A"
          : "N/A",
        journeyType: journeyAvailable ? journeyData?.type || "N/A" : "N/A",
        progress: data?.progress || 0,
        routeCoordinates: journeyData?.wayPointsPolyLine || [],
        stops: sortedStops,
        geofence: journeyData?.geofence || [],
        status: data?.journeyStatus || "unknown",
        journeyAvailable,
      };
    });
  }, [responsedata]);

  const pathData = useMemo(() => {
    if (!window.google || !window.google.maps || !window.google.maps.geometry) {
      return null;
    }

    if (!selectedVehicle || !selectedVehicle.routeCoordinates) return null;

    try {
      const fullPath = window.google.maps.geometry.encoding.decodePath(selectedVehicle.routeCoordinates)
        .map(p => ({ lat: p.lat(), lng: p.lng() }));

      if (fullPath.length === 0) return null;

      let minDistance = Infinity;
      let matchIndex = 0;
      const vehiclePos = selectedVehicle.position;

      fullPath.forEach((point, index) => {
        const dist = getDistance(point, vehiclePos);
        if (dist < minDistance) {
          minDistance = dist;
          matchIndex = index;
        }
      });

      return {
        covered: fullPath.slice(0, matchIndex + 1),
        remaining: fullPath.slice(matchIndex)
      };
    } catch (error) {
      console.error("Error decoding path:", error);
      return null;
    }
  }, [selectedVehicle, window.google]);

  const filteredVehicles = useMemo(() => {
    const now = Date.now();

    // 🔥 Default: If no filter active, return all vehicles
    if (!activeFilter || activeFilter === "@total") return vehicles;

    return vehicles.filter((v) => {
      const speed = parseFloat(v.speed);
      const isStale = v.rawTime && v.rawTime + 3600000 < now;
      const isIgnitionOn = v.ignition === "ON";

      switch (activeFilter) {
        case "@offline": return isStale;
        case "@running": return !isStale && isIgnitionOn && speed >= 0.25;
        case "@idle": return !isStale && isIgnitionOn && speed < 0.25;
        case "@parked": return !isStale && !isIgnitionOn;
        case "@onroute": return v.journeyAvailable === true;
        default: return true;
      }
    });
  }, [vehicles, activeFilter]);

  useEffect(() => {
    if (!selectedVehicleNumber) {
      setSelectedVehicle(null);
      setSelectedStop(null);
      setOpenInfoVehicleId(null);
      return;
    }

    const vehicle = vehicles.find(
      (v) =>
        String(v.vehicleNumber).trim() ===
        String(selectedVehicleNumber).trim()
    );

    setSelectedVehicle(vehicle || null);
  }, [vehicles, selectedVehicleNumber]);

  useEffect(() => {
    if (activeFilter) {
      setSelectedVehicle(null);
      dispatch(setSelectedVehicleNumber(null));
    }
  }, [activeFilter]);

  useEffect(() => {
    if (autoFocus && selectedVehicle && mapRef.current) {
      if (selectedVehicle?.position?.lat && selectedVehicle?.position?.lng) {
        mapRef.current.panTo(selectedVehicle.position);
        mapRef.current.setZoom(17);
      }
    }
  }, [selectedVehicle, autoFocus, activeFilter]);

  useEffect(() => {
    if (autoFocus && selectedJourneyId && journeys.length > 0 && mapRef.current) {
      const journey = journeys.find(j => j.journeyId === selectedJourneyId);
      if (journey?.encodedPath) {
        const path = window.google.maps.geometry.encoding.decodePath(journey.encodedPath);
        const bounds = new google.maps.LatLngBounds();
        path.forEach(p => bounds.extend(p));
        mapRef.current.fitBounds(bounds);
      }
    }
  }, [selectedJourneyId, journeys, autoFocus]);

  useEffect(() => {
    if (!autoFocus) return;

    if (selectedVehicle) {
      centerRef.current = selectedVehicle.position;
    } else if (filteredVehicles.length > 0) {
      centerRef.current = {
        lat:
          filteredVehicles.reduce((sum, v) => sum + v.position.lat, 0) /
          filteredVehicles.length,
        lng:
          filteredVehicles.reduce((sum, v) => sum + v.position.lng, 0) /
          filteredVehicles.length,
      };
    }
  }, [selectedVehicle, autoFocus, filteredVehicles]);

  useEffect(() => {
    // Check if latestUpdates has data
    const hasData = latestUpdates && Object.keys(latestUpdates).length > 0;

    if (hasData && !hasFocusedOnceRef.current && mapRef.current) {
      const bounds = new window.google.maps.LatLngBounds();

      vehicles.forEach((v) => {
        if (v.position?.lat && v.position?.lng) {
          bounds.extend(v.position);
        }
      });

      if (!bounds.isEmpty()) {
        mapRef.current.fitBounds(bounds);
        hasFocusedOnceRef.current = true; // ✅ only once
      }
    }
  }, [latestUpdates, vehicles]);

  //added new effect for singal vehicle focus
  useEffect(() => {
    if (
      selectedVehicle &&
      mapRef.current &&
      selectedVehicle?.position?.lat &&
      selectedVehicle?.position?.lng
    ) {
      mapRef.current.panTo(selectedVehicle.position);
      mapRef.current.setZoom(17);
    }
  }, [selectedVehicle?.vehicleNumber]);

  useEffect(() => {
    if (autoFocus && filteredVehicles.length > 0 && mapRef.current && !selectedVehicle) {
      const bounds = new google.maps.LatLngBounds();
      filteredVehicles.forEach((v) => bounds.extend(v.position));
      mapRef.current.fitBounds(bounds);
    }
  }, [autoFocus, filteredVehicles, selectedVehicle]);

  const mapCenter = centerRef.current;

  // Helper function taaki markers ko clustered aur un-clustered dono modes mein reuse kar sakein
  const renderVehicles = (clusterer = undefined) => {
    return filteredVehicles.map((vehicle) => (
      <SmoothMarker
        key={vehicle.vehicleNumber}
        position={vehicle.position}
        vehicle={vehicle}
        clusterer={clusterer} // Agar disabled hoga toh ye undefined jayega
        animation={window.google.maps.Animation.DROP}
        onClick={() => {
          onVehicleSelect?.(vehicle.vehicleNumber);
        }}
      >
        {(openInfoVehicleId === vehicle.vehicleNumber || showAllLabels) && (
          <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)}>
            <MDBox p={0} sx={{ whiteSpace: "nowrap" }}>
              <MDTypography variant="subtitle2" fontWeight="bold" display="block" sx={{ fontSize: FONT_SIZE.subtitle, lineHeight: 1.3 }}>
                {vehicle.vehicleNumber}
              </MDTypography>
              <MDTypography variant="caption" color="text" fontWeight="regular" display="block" sx={{ fontSize: FONT_SIZE.small }}>
                {vehicle.vehicleNickName}
              </MDTypography>
            </MDBox>
          </InfoWindow>
        )}
      </SmoothMarker>
    ));
  };

  if (loadError) {
    return (
      <MDBox p={2}>
        <MDTypography variant="body2" color="error">
          Failed to load Google Maps. Please check your internet connection or API key.
        </MDTypography>
      </MDBox>
    );
  }

  if (!isLoaded) {
    return (
      <MDBox p={2}>
        <MDTypography variant="body2" color="text">
          Loading map...
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: isMobile ? 12 : 20,
          right: isMobile ? 12 : 20,
          zIndex: 1,
          ...controlClusterStyle(isMobile, darkMode),
        }}
      >
        <button
          style={getControlBtnStyle(isMobile, showAllLabels)}
          onClick={() => setShowAllLabels(!showAllLabels)}
          title={showAllLabels ? "Hide Labels" : "Show Labels"}
          onMouseEnter={(e) => { if (!showAllLabels) e.currentTarget.style.background = "rgba(148,163,184,0.16)"; }}
          onMouseLeave={(e) => { if (!showAllLabels) e.currentTarget.style.background = "transparent"; }}
        >
          <img
            src={showAllLabels ? label_dark : label}
            style={{ width: isMobile ? 18 : 20, height: isMobile ? 18 : 20 }}
            alt="labels"
          />
        </button>

        <button
          style={getControlBtnStyle(isMobile, mapType === "hybrid")}
          onClick={() =>
            setMapType((prev) => (prev === "roadmap" ? "hybrid" : "roadmap"))}
          title={mapType === "roadmap" ? "Satellite View" : "Roadmap View"}
          onMouseEnter={(e) => { if (mapType !== "hybrid") e.currentTarget.style.background = "rgba(148,163,184,0.16)"; }}
          onMouseLeave={(e) => { if (mapType !== "hybrid") e.currentTarget.style.background = "transparent"; }}
        >
          <img
            src={satellite}
            // src={mapType === "hybrid" ? satellite : satellite_dark}
            style={{ width: isMobile ? 18 : 20, height: isMobile ? 18 : 20 }}
            alt="map-type"
          />
        </button>

        <button
          style={getControlBtnStyle(isMobile, autoFocus)}
          onClick={() => setAutoFocus(!autoFocus)}
          title={autoFocus ? "Focus: ON (Click to Disable)" : "Focus: OFF (Click to Enable)"}
          onMouseEnter={(e) => { if (!autoFocus) e.currentTarget.style.background = "rgba(148,163,184,0.16)"; }}
          onMouseLeave={(e) => { if (!autoFocus) e.currentTarget.style.background = "transparent"; }}
        >
          <img
            src={focus_light}
            // src={autoFocus ? focus : darkMode ? focus_light : focus_dark}
            style={{ width: isMobile ? 18 : 20, height: isMobile ? 18 : 20 }}
            alt="focus"
          />
        </button>

        <button
          style={getControlBtnStyle(isMobile, isClusteringEnabled)}
          onClick={() => setIsClusteringEnabled(!isClusteringEnabled)}
          title={isClusteringEnabled ? "Disable Clustering" : "Enable Clustering"}
          onMouseEnter={(e) => { if (!isClusteringEnabled) e.currentTarget.style.background = "rgba(148,163,184,0.16)"; }}
          onMouseLeave={(e) => { if (!isClusteringEnabled) e.currentTarget.style.background = "transparent"; }}
        >
          {/* Custom SVG Icon - Asset import karne ki zarurat nahi padegi */}
          <svg
            width={isMobile ? 18 : 20}
            height={isMobile ? 18 : 20}
            viewBox="0 0 24 24"
            fill="none"
            stroke={isClusteringEnabled ? SIGNAL.violet : "#94A3B8"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="3"></circle>
            <circle cx="19" cy="5" r="2"></circle>
            <circle cx="5" cy="5" r="2"></circle>
            <circle cx="19" cy="19" r="2"></circle>
            <circle cx="5" cy="19" r="2"></circle>
            <path d="M10.5 10.5L7 7 M13.5 10.5L17 7 M10.5 13.5L7 17 M13.5 13.5L17 17"></path>
          </svg>
        </button>
      </div>

      <GoogleMap
        mapContainerStyle={containerStyle}
        // center={autoFocus ? mapCenter : undefined}
        center={mapCenter || defaultCenter}
        zoom={selectedVehicle ? 15 : 9}
        onLoad={(map) => (mapRef.current = map)}
        options={{
          mapTypeId: mapType,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          styles: darkMode && mapType === "roadmap" ? DARK_MAP_STYLES : [],
        }}
      >
        {selectedVehicle && (activeFilter === "@total" || !activeFilter || searchQuery === selectedVehicle.vehicleNumber) ? (
          <>
            {animatedPosition && (
              <Circle
                center={animatedPosition}
                radius={pulseRadius}
                options={{
                  strokeColor: getVehicleColor(selectedVehicle),
                  strokeOpacity: 0.3,
                  strokeWeight: 2,
                  fillColor: getVehicleColor(selectedVehicle),
                  fillOpacity: pulseOpacity,
                }}
              />
            )}
            <SmoothMarker
              key={selectedVehicle.vehicleNumber}
              position={selectedVehicle.position}
              vehicle={selectedVehicle}
              onPositionChange={setAnimatedPosition}
              animation={google.maps.Animation.DROP}
              onClick={() => {
                setOpenInfoVehicleId((prev) =>
                  prev === selectedVehicle.vehicleNumber ? null : selectedVehicle.vehicleNumber
                );
              }}
            >
              {(openInfoVehicleId === selectedVehicle.vehicleNumber || showAllLabels) && (
                <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)} options={{ maxWidth: 160 }}>
                  <MDBox p={0} sx={{ overflow: "hidden", display: "block", whiteSpace: "nowrap", lineHeight: 1.3 }}>
                    <MDTypography variant="subtitle2" fontWeight="bold" display="block" sx={{ fontSize: FONT_SIZE.subtitle }}>
                      {selectedVehicle.vehicleNumber}
                    </MDTypography>
                    <MDTypography variant="caption" color="text" fontWeight="regular" display="block" sx={{ fontSize: FONT_SIZE.small }}>
                      {selectedVehicle.vehicleNickName}
                    </MDTypography>
                  </MDBox>
                </InfoWindow>
              )}
            </SmoothMarker>
          </>
        ) : (
          <>
            {isClusteringEnabled ? (
              <MarkerClusterer
                options={{
                  gridSize: 60,
                  minimumClusterSize: 2,
                  imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
                }}
              >
                {(clusterer) => <>{renderVehicles(clusterer)}</>}
              </MarkerClusterer>
            ) : (
              // Jab clustering disable hogi, directly array render hoga
              <>{renderVehicles()}</>
            )}
          </>
        )}

        {!selectedJourneyId && pathData && (
          <>
            <Polyline
              path={pathData.covered}
              options={{
                strokeColor: "#2bbf9f",
                strokeOpacity: 1.0,
                strokeWeight: 4,
              }}
            />
            <Polyline
              path={pathData.remaining}
              options={{
                strokeColor: "#f07846",
                strokeOpacity: 0.8,
                strokeWeight: 4,
                lineDashInterval: 10,
              }}
            />
          </>
        )}

        {selectedJourneyId && journeys.length > 0 && (
          <>
            {(() => {
              const journey = journeys.find(j => j.journeyId === selectedJourneyId);
              if (journey?.encodedPath) {
                return (
                  <Polyline
                    path={window.google.maps.geometry.encoding.decodePath(journey.encodedPath)}
                    options={{
                      strokeColor: "#000000",
                      strokeOpacity: 1.0,
                      strokeWeight: 4,
                    }}
                  />
                );
              }
            })()}

            {catchmentFullData?.data?.allWayPoints
              ?.find(j => j.journeyId === selectedJourneyId)
              ?.stopPoints?.map((stop, index) => (
                <Marker
                  key={`catchment-stop-${index}`}
                  position={{
                    lat: parseFloat(stop.location.latitude),
                    lng: parseFloat(stop.location.longitude),
                  }}
                  icon={{
                    url: StopIcon,
                    scaledSize: new window.google.maps.Size(28, 28),
                  }}
                  label={{
                    color: "#fff",
                    text: `${index + 1}`,
                    fontSize: `${FONT_SIZE_PX.small}px`,
                    fontWeight: "bold",
                  }}
                  onClick={() => {
                    const currentId = `c-${index}`;
                    setSelectedStop((prev) =>
                      prev?.id === currentId ? null : { id: currentId, name: stop.locationName }
                    );
                  }}
                >
                  {selectedStop?.id === `c-${index}` && (
                    <InfoWindow onCloseClick={() => setSelectedStop(null)}>
                      <MDBox p={0} sx={{ whiteSpace: "nowrap" }}>
                        <MDTypography variant="subtitle2" fontWeight="bold" sx={{ fontSize: FONT_SIZE.subtitle }}>
                          {stop.locationName}
                        </MDTypography>
                      </MDBox>
                    </InfoWindow>
                  )}
                </Marker>
              ))}
          </>
        )}

        {!selectedJourneyId &&
          selectedVehicle?.journeyAvailable &&
          Array.isArray(selectedVehicle?.stops) &&
          selectedVehicle.stops.map((stop, index) => {
            return (
              <Marker
                key={stop.stopId || index}
                position={{
                  lat: parseFloat(stop.location.latitude),
                  lng: parseFloat(stop.location.longitude),
                }}
                icon={{
                  url: StopIcon,
                  scaledSize: new window.google.maps.Size(28, 28),
                }}
                label={{
                  color: "#fff",
                  text: String(stop.displayIndex),
                  fontSize: `${FONT_SIZE_PX.small}px`,
                  fontWeight: "bold",
                }}
                onClick={() => {
                  setSelectedStop((prev) =>
                    prev?.id === stop.stopId ? null : { id: stop.stopId, name: stop.locationName }
                  );
                }}
              >
                {selectedStop?.id === stop.stopId && (
                  <InfoWindow onCloseClick={() => setSelectedStop(null)}>
                    <MDBox p={0} sx={{ whiteSpace: "nowrap" }}>
                      <MDTypography variant="subtitle2" fontWeight="bold" sx={{ fontSize: FONT_SIZE.subtitle }}>
                        {stop.displayIndex}. {stop.locationName}
                      </MDTypography>
                    </MDBox>
                  </InfoWindow>
                )}
              </Marker>
            );
          })}

        {selectedVehicle?.geofence?.length > 0 && (
          <Polygon
            paths={selectedVehicle.geofence}
            options={{
              strokeColor: "#FF9800",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#FF9800",
              fillOpacity: 0.35,
            }}
          />
        )}

        {(geoFences || []).map((geofence, index) => {
          const data = geofence.data || {};

          if (geofence.type === "POLYGON" && Array.isArray(data.coordinates) && data.coordinates.length > 0) {
            const paths = data.coordinates.map(([lng, lat]) => ({ lat, lng }));
            return (
              <Polygon
                key={`geofence-polygon-${geofence.filterId || index}`}
                paths={paths}
                options={{
                  strokeColor: "#666666",
                  strokeOpacity: 1,
                  strokeWeight: 2,
                  fillColor: "#0c0808",
                  fillOpacity: 0.3,
                }}
              />
            );
          }

          const location = data.location;
          const radius = data.radius || 100;
          if (!location?.latitude || !location?.longitude) return null;
          return (
            <Circle
              key={`geofence-circle-${geofence.filterId || index}`}
              center={{ lat: location.latitude, lng: location.longitude }}
              radius={radius}
              options={{
                strokeColor: "#666666",
                strokeOpacity: 1,
                strokeWeight: 5,
                fillColor: "#0c0808",
                fillOpacity: 0.3,
              }}
            />
          );
        })}

        {/* {(geoFences || []).map((geofence, index) => {
          const location = geofence.data?.location;
          const radius = geofence.data?.radius || 100;
          if (!location?.latitude || !location?.longitude) return null;
          return (
            <Circle
              key={`circle-${index}`}
              center={{ lat: location.latitude, lng: location.longitude }}
              radius={radius}
              options={{
                strokeColor: "#666666",
                strokeOpacity: 1,
                strokeWeight: 5,
                fillColor: "#0c0808",
                fillOpacity: 0.3,
              }}
            />
          );
        })} */}
      </GoogleMap>
      <VehicleDashboard
        vehicle={selectedVehicle}
        onClose={() => {
          setSelectedVehicle(null);
          dispatch(setSelectedVehicleNumber(null));
        }}
      />
    </>
  );
};

GoogleMapView.propTypes = {
  onVehicleSelect: PropTypes.func,
};

export default GoogleMapView;